import cn from "classnames";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { START_DATE } from "../consts";
import { showAboutPopup, hidePopups, useSelector } from "../store";
// import '../output.css';
import '../index.css';
import '../home.css';


function getHoursRemaining() {
  const utcDate = new Date("2022-02-13T00:00:00Z").getTime();
  const offset = new Date().getTimezoneOffset();
  const time = new Date(utcDate + offset * 60 * 1000);
  const now = new Date();
  // const diff = now.getTime() - START_DATE.getTime();
  const diff = now.getTime() - time.getTime();
  console.log(now, diff)
  const hoursRemaining = 24 - ((diff / 1000 / 60 / 60) % 24);
  if (hoursRemaining > 0.95) {
    return hoursRemaining.toFixed(0);
  } else {
    return hoursRemaining.toFixed(1);
  }
}
export default function About() {
  const dispatch = useDispatch();
  // dispatch(showAboutPopup());
  const [hoursRemaining, setHoursRemaining] = useState(getHoursRemaining);
  const shown = useSelector((s) => s.popups.about);

  const goBack = () => {
    let newUrl: any = localStorage.getItem("prevUrl")
    window.location.href = newUrl
  }

  useEffect(() => {
    // Update hoursRemaining every time popup is opened
    if (shown) {
      setHoursRemaining(getHoursRemaining);
    }
  }, [shown]);

  return (
    <div className="font-about" style={{maxWidth:'550px', margin:'auto',height:'100%',display:'flex'}}>
    {/* <div className={cn("popup-wrapper")}> */}
      {/* <div className="z-10 absolute w-full h-full text-white dark:text-white bg-custom overflow-auto transition-all ease-in-out duration-500"> */}
        {/* <div className="w-full h-full overflow-y-auto overflow-x-hidden"> */}
          {/* <div className="max-w-[550px] w-full m-auto flex flex-row-reverse pr-4 pt-2">
          <button type="button" onClick={goBack} className="cursor-pointer bg-white dark:bg-custom text-black dark:text-gray-100 border border-gray-500 hover:text-black focus:outline-none font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center dark:border-gray-500 dark:hover:text-white">
<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><title>Close</title><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg></button>
          </div> */}


          <div id="tutorial" style={{width: '100%', height:'100%', overflow: 'auto', paddingLeft: '8px', paddingRight: '8px', fontSize: '50%', color: 'white', backgroundColor: 'rgb(24, 26, 27)'}}>
        <table onClick={goBack} style={{width: '100%', fontSize: '200%'}}>
            <tr>
                <td className="box" style={{border: 'none', borderStyle: 'double', width: '35%', cursor: 'pointer'}} id="leave_tutorial">back</td>
            </tr>
        </table>
        <h3>Guess all sixteen sedecordle words in 21 tries.</h3>
        <p>Each guess must be a valid 5 letter word. Hit the enter button to submit.<br/><br/>After each guess, the color of the tiles will change to show how close your guess was to the word.</p>
        <h2>Examples</h2>
        <table style={{width: '50%', borderSpacing:'0px', fontSize:'200%'}}>
            <tr>
                <td style={{width: '50%', padding: '0px'}}>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1" style={{backgroundColor:'#00cc88', color:'black'}}>C</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2">R</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3">O</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4">W</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5">N</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
        <p>The letter C is in the word and in the correct spot.<br/><br/></p>
        <table style={{width: '50%', borderSpacing:'0px', fontSize:'200%'}}>
            <tr>
                <td style={{width: '50%', padding: '0px'}}>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1">B</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2" style={{backgroundColor:'yellow', color:'black'}}>A</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3">D</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4">G</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5">E</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
        <p>The letter A is in the word but in the wrong spot.<br/><br/></p>
        <table style={{width: '50%', borderSpacing:'0px', fontSize:'200%'}}>
            <tr>
                <td style={{width: '50%', padding: '0px'}}>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1">C</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2">O</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3">M</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4">F</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5">Y</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
        <p>The letters C, O, M, F, Y are not in the word in any spot.<br/><br/>When you type a guess in sedecordle, you will guess that word for all sixteen words that you are solving. All sixteen words you are solving will be different.<br/></p>
        <table style={{width: '100%', borderSpacing:'0px', fontSize:'200%'}}>
            <tr>
                <td style={{width: '50%', padding: '0px'}}>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1">W</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2">O</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3">R</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4">L</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5">D</td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                </td>
                <td style={{width: '50%', padding: '0px'}}>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1">W</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2">O</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3" style={{backgroundColor:'yellow', color:'black'}}>R</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4">L</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5" style={{backgroundColor:'#00cc88', color:'black'}}>D</td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td style={{width: '50%', padding: '0px'}}>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1">W</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2">O</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3">R</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4" style={{backgroundColor:'yellow', color:'black'}}>L</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5">D</td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                </td>
                <td style={{width: '50%', padding: '0px'}}>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1">W</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2" style={{backgroundColor:'#00cc88', color:'black'}}>O</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3">R</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4">L</td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5" style={{backgroundColor:'yellow', color:'black'}}>D</td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                    <table style={{width: '100%'}} className="table_guesses">
                        <tr>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,1"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,2"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,3"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,4"></td>
                            <td className="box-1 button" width="20%" id="boxdemo1,1,5"></td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
        <p>For the guess WORLD:
            <ol>
                <li>The top left word has none of the letters.</li>
                <li>The top right word has the R in the wrong spot and the D in the correct spot.</li>
                <li>The bottom left word has the L in the wrong spot.</li>
                <li>The bottom right word has the O in the right spot and the D in the wrong spot.</li>
            </ol>
        </p>
        <p>You have 21 guesses to get all 16 words correct. Good luck!</p>
        <p>A new sedecordle will be available each day!<br/><br/></p>

        <div className="text-lg">
              <h3 className="underline">Sedec-order</h3>
              <p>Sedecorder is similar to the original Sedecordle game with the following changes:</p>
              <p>Only one unsolved word is visible at a time. Once you solve a word, the next board for the next board is unlocked.</p>
            </div>
            <div className="flex flex-row items-center justify-between mb-8 ads-about">

            </div>
    </div>
    

          </div>
          // </div>
          // </div>
          // </div>

        );
}

